import copy from '../../copy/en/shell.json' with { type: 'json' };
import { Compass } from "lucide-react";
import { Link } from "react-router";
import { EmptyState } from "../components/ui/EmptyState.js";
import { PageHeader } from "../components/ui/PageHeader.js";

export function NotFoundPage() {
  return (
    <>
      <PageHeader title={copy.NotFoundPage.pageNotFound} description={copy.NotFoundPage.theAddressDoesNotMatchAnyScreen} />
      <EmptyState
        icon={Compass}
        title={copy.NotFoundPage.nothingHere}
        message={copy.NotFoundPage.checkTheAddressOrHeadBackTo}
        action={
          <Link to="/" className="btn btn--primary">{copy.NotFoundPage.goToDashboard}</Link>
        }
      />
    </>
  );
}
